import { useMap } from 'react-leaflet';
import { useEffect } from 'react';
import React from 'react';

interface ZoomToProps {
    zoom?: number;
    zoomToLat?: number | null;
    zoomToLng?: number | null;
}

function ZoomTo({ zoom = 13, zoomToLat, zoomToLng }: ZoomToProps) {
    const map = useMap();

    useEffect(() => {
        if (zoomToLat != null && zoomToLng != null) {
            map.setView([zoomToLat, zoomToLng], zoom, { animate: true });
        }
    }, [zoomToLat, zoomToLng, zoom, map]);

    return null;
}

export const LeafLetZoomTo = React.memo(ZoomTo);
